import React from 'react';
import PropTypes from 'prop-types';

import { colorGray } from 'styles/layout/colors';

const IconQuotes = ({
  className = '',
  color = colorGray,
  height = 48,
  width = 48,
}) => (
  <svg
    className={className}
    fill="none"
    height={height}
    viewBox="0 0 48 48"
    width={width}
  >
    <path
      d="M28.7812 17.8438H20.0312C19.4269 17.8438 18.9375 18.3332 18.9375 18.9375C18.9375 19.5418 19.4269 20.0312 20.0312 20.0312H28.7812C29.3856 20.0312 29.875 19.5418 29.875 18.9375C29.875 18.3332 29.3856 17.8438 28.7812 17.8438Z"
      fill={color}
    />
    <path
      d="M28.7812 23.2812H20.0312C19.4269 23.2812 18.9375 23.7707 18.9375 24.375C18.9375 24.9793 19.4269 25.4687 20.0312 25.4687H28.7812C29.3856 25.4687 29.875 24.9793 29.875 24.375C29.875 23.7707 29.3856 23.2812 28.7812 23.2812Z"
      fill={color}
    />
    <path
      d="M37.5316 8H16.1158C14.05 8 12.375 9.67482 12.375 11.7408V29.875H11.0406C9.36444 29.8805 8.00546 31.2394 8 32.9156V36.1969C8 38.4828 9.75 40.7798 13.6658 40.7798H32.6096C34.7027 40.7798 36.4078 39.0995 36.4379 37.0064V18.9377H37.7722C39.4539 18.9322 40.8129 17.5677 40.8129 15.8861V11.2815C40.8129 9.46996 39.3431 8.00024 37.5316 8.00024V8ZM13.6658 38.625C11.4783 38.625 10.1877 37.7062 10.1877 36.2297V32.9484C10.1877 32.4767 10.5691 32.0953 11.0408 32.0953H27.6875C27.9773 32.0953 28.2563 32.2101 28.4613 32.4152C28.6664 32.6203 28.7812 32.8992 28.7812 33.189V37.0061C28.7812 37.5735 28.9084 38.1341 29.1531 38.6468L13.6658 38.625ZM34.25 33.1562V37.0063C34.25 37.9127 33.5158 38.6469 32.6094 38.6469C31.7029 38.6469 30.9688 37.9127 30.9688 37.0063V33.2C30.9688 31.3885 29.499 29.9187 27.6875 29.9187H14.5625V11.7405C14.5625 10.8832 15.2584 10.1873 16.1156 10.1873H34.4469C34.3197 10.5387 34.2527 10.9078 34.25 11.2811V33.1562ZM38.625 15.8858C38.6277 16.1142 38.5389 16.3343 38.3789 16.4956C38.219 16.6583 38.0002 16.7499 37.7719 16.7499H36.4375V11.2812C36.4375 10.6769 36.9269 10.1874 37.5312 10.1874C38.1356 10.1874 38.625 10.6769 38.625 11.2812L38.625 15.8858Z"
      fill={color}
    />
  </svg>
);

IconQuotes.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default IconQuotes;
